import draftToHtml from "draftjs-to-html";

export const TIPTAP_FORMAT = "tiptap";

export function makeEmptyDescriptionContent() {
    return {
        format: TIPTAP_FORMAT,
        json: { type: "doc", content: [] },
        html: "",
    };
}

export function parseStoredContent(content) {
    if (!content) return null;
    let parsed = content;
    try {
        if (typeof parsed === "string") {
            parsed = JSON.parse(parsed);
            if (typeof parsed === "string") parsed = JSON.parse(parsed);
        }
    } catch {
        return null;
    }
    return parsed;
}

export function isTipTapContent(content) {
    const c = parseStoredContent(content);
    return c?.format === TIPTAP_FORMAT && (c.json || c.html);
}

export function isDraftContent(content) {
    const c = parseStoredContent(content);
    return c?.blocks && Array.isArray(c.blocks);
}

function extractTextFromTiptapNode(node) {
    if (!node) return "";
    if (node.type === "text") return node.text || "";
    if (!Array.isArray(node.content)) return "";
    return node.content.map(extractTextFromTiptapNode).join(" ");
}

export function extractPlainText(content) {
    const c = parseStoredContent(content);
    if (!c) return typeof content === "string" ? content : "";

    if (c.format === TIPTAP_FORMAT) {
        if (c.html) {
            return c.html.replace(/<[^>]+>/g, " ").replace(/\s+/g, " ").trim();
        }
        if (c.json) return extractTextFromTiptapNode(c.json);
        return "";
    }

    if (c.blocks && Array.isArray(c.blocks)) {
        return c.blocks.map((b) => b.text || "").join(" ");
    }

    return "";
}

export function draftRawToHtml(raw) {
    try {
        const cleaned = parseStoredContent(raw);
        if (!cleaned?.blocks) return "";
        return draftToHtml(cleaned);
    } catch {
        return "";
    }
}

export function resolveTipTapInitialContent(content) {
    if (isTipTapContent(content)) {
        const c = parseStoredContent(content);
        if (c.json) return c.json;
        if (c.html) return c.html;
    }
    if (isDraftContent(content)) {
        const html = draftRawToHtml(content);
        return html || "";
    }
    return "";
}

const toYouTubeEmbed = (url) => {
    if (!url) return null;
    if (url.includes("youtu.be/")) {
        return `https://www.youtube.com/embed/${url.split("youtu.be/")[1].split("?")[0]}`;
    }
    if (url.includes("watch?v=")) {
        return `https://www.youtube.com/embed/${url.split("watch?v=")[1].split("&")[0]}`;
    }
    return null;
};

/** Renders description section content to HTML (TipTap + legacy Draft.js). */
export function descriptionContentToHtml(content) {
    const parsed = parseStoredContent(content);
    if (!parsed) return "";

    if (parsed.format === TIPTAP_FORMAT) {
        return parsed.html || "";
    }

    if (parsed.blocks && Array.isArray(parsed.blocks)) {
        return draftToHtml(parsed, {}, false, (entity, text) => {
            if (entity.type === "EMBEDDED_LINK") {
                const embedUrl = toYouTubeEmbed(entity.data?.src);
                if (!embedUrl) return text;
                return `
          <div style="margin:24px 0; position:relative; padding-top:56.25%;">
            <iframe
              src="${embedUrl}"
              style="position:absolute; top:0; left:0; width:100%; height:100%;"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen
            ></iframe>
          </div>
        `;
            }
            return text;
        });
    }

    return "";
}
